import { startOfToday } from '@nestech/utils';
import { MemberFeatureResolver } from '@web/service';
import { DateTime } from 'luxon';

/** Resolves the member's page components until the member API delivers them. */
export const pbuPageComponents: MemberFeatureResolver = member => {
  const retirementDate = DateTime.fromJSDate(member.birthDate!)
    .plus({ months: member.statePensionAge! + 1 })
    .startOf('month');
  const features = [
    'savingsSummary',
    'pbu.growFund',
    'disbursementProjection',
    ...(retirementDate > startOfToday() ? (['pensionCountdown'] as const) : []),
    'investmentProfileSelectScenario',
    'investmentProfileRiskPhaseout',
    'investmentProfileDistribution',
  ].map(name => ({
    name,
  }));
  return { features };
};
